module.exports = __webpack_public_path__ + "img/ico_heart_filled--orange.b3976001.svg";